import { render, staticRenderFns } from "./TipoActivitySelection.vue?vue&type=template&id=3fbd4632&"
import script from "./TipoActivitySelection.vue?vue&type=script&lang=js&"
export * from "./TipoActivitySelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports